import {ECompanyNewsTab} from './definitions';

export default {
  tabs: {
    [ECompanyNewsTab.BLOG]: 'Блог',
    [ECompanyNewsTab.CASES]: 'Кейсы',
  },
};
